export enum EStorageKey {
  ManuallyManage = 'ManuallyManage',
}
